import * as React from "react";
import {DATA_STATE} from "../../users/contexts/UsersDashboardContext";
import {
    AvailableMassivePatchesInfo,
    JSONAvailableMassivePatch,
    ValidateEquipment,
} from "./MassiveActionsTypesAndFunctions";
import {executeMassiveAction, validatesEquipmentsCodes} from "./MassiveActionsController";

interface MassiveActionsContextType {
    validateCodes: (codes: string[]) => Promise<ValidateEquipment[]>;
    validatedEquipmentsInfo: {
        validatedEquipments: ValidateEquipment[],
        validatedEquipmentState: DATA_STATE
    }
    availableMassivePatchesInfo: AvailableMassivePatchesInfo,
    executeMassiveAction: (availableMassivePatches: JSONAvailableMassivePatch[]) => Promise<any>
    resetValidatedEquipments: () => void;
    stackManager: any
}

export enum MassiveActionProcessState { INITIAL, FAILURE, PENDING}

export const MassiveActionsContext = React.createContext<MassiveActionsContextType>({} as any);

interface MassiveActionsProviderProps {
    availableMassivePatchesInfo: AvailableMassivePatchesInfo
    stackManager: any
}

export const MassiveActionsProvider: React.FC<MassiveActionsProviderProps> = ({
                                                                                  availableMassivePatchesInfo,
                                                                                  stackManager,
                                                                                  children
                                                                              }) => {
    const [validatedEquipments, setValidatedEquipments] = React.useState<ValidateEquipment[]>()
    const [validatedEquipmentState, setValidatedEquipmentState] = React.useState<DATA_STATE>(DATA_STATE.isLoading)

    const validateCodes = async (codes: string[]) => {
        setValidatedEquipmentState(DATA_STATE.isLoading)
        const list = await validatesEquipmentsCodes(codes);
        setValidatedEquipments(list);
        setValidatedEquipmentState(DATA_STATE.loaded);
        return list;
    }

    const resetValidatedEquipments = () => {
        setValidatedEquipments([])
    }

    return (
        <MassiveActionsContext.Provider
            value={{
                validateCodes,
                validatedEquipmentsInfo: {validatedEquipments, validatedEquipmentState},
                availableMassivePatchesInfo,
                executeMassiveAction,
                resetValidatedEquipments,
                stackManager
            }}
        >
            {children}
        </MassiveActionsContext.Provider>
    );
}

